import { GREY } from '@/constants/color';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Tooltip, TooltipProps, styled, tooltipClasses } from '@mui/material';
import classNames from 'classnames';

interface ITooltipProps extends Pick<TooltipProps, 'title' | 'arrow' | 'placement' | 'sx'> {
  maxWidth?: number | string;
  className?: string;
  popperClassName?: string;
}

interface IExtendedTooltipProps extends TooltipProps {
  maxWidth: ITooltipProps['maxWidth'];
  popperClassName?: string;
}

const StyledTooltip = styled(
  ({ className, popperClassName, maxWidth, ...props }: IExtendedTooltipProps) => (
    <Tooltip {...props} classes={{ popper: popperClassName }} className={className} />
  ),
  {
    shouldForwardProp: prop => prop !== 'maxWidth' && prop !== 'popperClassName',
  },
)(({ maxWidth }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: maxWidth ?? 300,
  },
}));

const InfoTooltip = ({
  title,
  className = 'right-[-17px] top-[-12px]',
  popperClassName,
  arrow = true,
  placement = 'top',
  maxWidth,
  sx,
}: ITooltipProps) => {
  return (
    <StyledTooltip
      className={classNames('absolute', className)}
      popperClassName={popperClassName}
      sx={sx}
      title={title}
      arrow={arrow}
      placement={placement}
      maxWidth={maxWidth}
    >
      <InfoOutlined sx={{ width: '16px', height: '16px', color: GREY, displayPrint: 'none' }} />
    </StyledTooltip>
  );
};

export default InfoTooltip;
